'use client';

import Link from 'next/link';
import PlainTextWrapper from '@/helpers/Wrappers/PlainTextWrapper/PlainTextWrapper';
import { trackAdobeClick } from '@/utils/adobe/click';
import { useGlobalLabels } from '@/context/GlobalLabelContext';
import { AnchorItem } from '@/utils/in-page-navigation';

/** Class names shared by both column renderers. */
export interface ColumnStyles {
  wrapper: string;
  list: string;
  link: string;
}

// Auto-generated column built from H2 anchors discovered on the page.
// Client component: reads the "On this page" heading from GlobalLabelsContext
// and wires Adobe click tracking on each anchor link.
export const AnchorColumn = ({
  items,
  headingClassName,
  styles,
}: {
  items: AnchorItem[];
  headingClassName: string;
  styles: ColumnStyles;
}) => {
  const { globalLabels } = useGlobalLabels();

  return (
    <div className={styles.wrapper}>
      <PlainTextWrapper
        content={globalLabels.on_this_page_label}
        cslpAttribute={globalLabels.$?.on_this_page_label}
        tag="h2"
        className={headingClassName}
        isDangerouslySetInnerHTML
      />
      <ul className={styles.list}>
        {items.map(({ id, text }) => (
          <li key={id}>
            <Link
              href={`#${id}`}
              className={styles.link}
              onClick={(e) =>
                trackAdobeClick(
                  {
                    clickName: text.replace(/<[^>]*>/g, ''),
                    clickLocation: 'InPageNavigation',
                    clickType: 'inpagenavigation-link',
                    clickUrl: 'InPageNavigation Anchor',
                  },
                  e
                )
              }
            >
              <PlainTextWrapper content={text} isDangerouslySetInnerHTML />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
